import { useRef } from 'react'
import { NormalizedTask, SubTab } from '@opallabs/wormhole/types'
import { Runnable } from '../types'
import { BucketedTasks } from './types'

interface CheckpointCreators {
  createToDoCheckpoint: Runnable
  createUpcomingCheckpoint: Runnable
  createOverdueCheckpoint: Runnable
  createCompletedCheckpoint: Runnable
}

interface UseCheckpointArg {
  completedTasksLoading: boolean
  createCheckpoint: (subTab: SubTab, items: NormalizedTask[]) => void
  overdueTasksLoading: boolean
  tasks: BucketedTasks
  todoTasksLoading: boolean
  upcomingTasksLoading: boolean
}

type UseCheckpointCreators = (arg: UseCheckpointArg) => CheckpointCreators

export const useCheckpointCreators: UseCheckpointCreators = ({
  completedTasksLoading,
  createCheckpoint,
  overdueTasksLoading,
  tasks,
  todoTasksLoading,
  upcomingTasksLoading,
}) => {
  const toDoCheckpointCreated = useRef(false)
  const upcomingCheckpointCreated = useRef(false)
  const overdueCheckpointCreated = useRef(false)
  const completedCheckpointCreated = useRef(false)

  const createToDoCheckpoint: Runnable = () => {
    if (
      tasks.todo.length > 0 &&
      !toDoCheckpointCreated.current &&
      !todoTasksLoading
    ) {
      toDoCheckpointCreated.current = true
      createCheckpoint('Pending', tasks.todo)
    }
  }

  const createUpcomingCheckpoint: Runnable = () => {
    if (
      tasks.upcoming.length > 0 &&
      !upcomingCheckpointCreated.current &&
      !upcomingTasksLoading
    ) {
      upcomingCheckpointCreated.current = true
      createCheckpoint('Upcoming', tasks.upcoming)
    }
  }

  const createOverdueCheckpoint: Runnable = () => {
    if (
      tasks.overdue.length > 0 &&
      !overdueCheckpointCreated.current &&
      !overdueTasksLoading
    ) {
      overdueCheckpointCreated.current = true
      createCheckpoint('Overdue', tasks.overdue)
    }
  }

  const createCompletedCheckpoint: Runnable = () => {
    if (
      tasks.completed.length > 0 &&
      !completedCheckpointCreated.current &&
      !completedTasksLoading
    ) {
      completedCheckpointCreated.current = true
      createCheckpoint('Completed', tasks.completed)
    }
  }

  return {
    createToDoCheckpoint,
    createUpcomingCheckpoint,
    createOverdueCheckpoint,
    createCompletedCheckpoint,
  }
}
